module.exports = __webpack_public_path__ + "img/14_14.eaa68bad.png";